import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';

export type SetLinkedTasksAllowedParams = {
  readonly scheduleIds: string[];
  readonly shouldAllowLinkedTasks: boolean;
}

export type SetLinkedTasksAllowedResult = IEmptyResult;

export class SetLinkedTasksAllowedRequest extends Request<SetLinkedTasksAllowedParams, SetLinkedTasksAllowedResult> {
  constructor(params: SetLinkedTasksAllowedParams) {
    super('setLinkedTasksAllowed', params);
  }
}
